import { SET_CURRENT_PBI, CLEAR_CURRENT_PBI } from 'actions/payway';
const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_PBI:
      return action.payload;
    case CLEAR_CURRENT_PBI:
      return null;
    default:
      return state;
  }
}
